import React, { useEffect } from "react";

import { toast } from "react-toastify";

import PouchDb from "pouchdb";

import { host, pass, user } from "../conf";

const usePouchListner = ({
  db,
  setChanges,
  data = [1, 2, 3],
  resetQuery = () => {},
}) => {
  const DB = new PouchDb(db);

  useEffect(() => {
    const rep = DB.replicate
      .from(`https://${user}:${pass}@${host}/${db}`, {
        live: true,
        retry: true,
      })
      .on("change", function (info) {
        // handle change

        setChanges((c) => c + 1);

        if (data.length === 0) {
          setTimeout(() => {
            resetQuery();
          }, 4000);
        }
        //toast.info("Live changes detected");
      })
      .on("paused", function (err) {
        // replication paused (e.g. replication up to date, user went offline)
        //toast.info("Paused replication");
      })
      .on("active", function () {
        // replicate resumed (e.g. new changes replicating, user went back online)
        //toast.info("Resume replication");
      })
      .on("denied", function (err) {
        // a document failed to replicate (e.g. due to permissions)

        toast.error("Denied Replication");
      })
      .on("complete", function (info) {
        // handle complete
        //toast.info("Replication complete");
      })
      .on("error", function (err) {
        // handle error
        toast.error("Replication error");
      });

    DB.compact()
      .then((res) => {})
      .catch((e) => {});

    return () => {
      rep.cancel();
    };
  }, []);
};

export default usePouchListner;
